import * as React from 'react';

import { Text } from '@lightspeed/flame/Text';
import capitalize from 'lodash/capitalize';

import { StyledPillBadge } from './ShipmentStatus.style';

interface Props {
  status: string;
  index?: number;
}

const ShipmentStatus: React.FC<Props> = ({ status, index = 0 }) => {
  let labelProps;
  switch (status) {
    case 'finished': {
      labelProps = {
        backgroundColor: 'gray-100',
        borderColor: 'gray-300',
      };
      break;
    }
    case 'received': {
      labelProps = {
        backgroundColor: 'orange-100',
        borderColor: 'orange-300',
      };
      break;
    }
    default: {
      labelProps = {
        backgroundColor: 'gray-100',
        borderColor: 'gray-300',
      };
    }
  }

  const shipmentStatus = capitalize(status);

  return (
    <StyledPillBadge {...labelProps}>
      <Text data-test={`shipment-status-${index}-text`}>{shipmentStatus}</Text>
    </StyledPillBadge>
  );
};

export default ShipmentStatus;
